import React from "react";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as intchaine from "./interface-chaine";
import * as intbd from "./interface-bd";
import * as mem from "./recopieLotFournisseur";
import axios from "axios";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { ImSpinner3 } from "react-icons/im";
import "./App.css";
import { DEBUG } from "./utilitaires";

export default function RappelLot() {

  const [inputLot, setInputLot] = useState(0);
  const [stringLot, setStringLot] = useState("");
  const [message, setMessage] = useState("");
  const [showRappel, setShowRappel] = useState(false);
  const handleCloseRappel = () => setShowRappel(false);

  var lottemp = 0;
  //var stringLottemp = "";
  var messagetemp = "";

  function handleOnChange(e, value) {
    e.preventDefault();
    //stringLottemp = value.trim();
    //console.log(stringLottemp);
    setStringLot(value);

  }

  async function handleRappelerLot(e, rappel) {
    // setShow(false);
    e.preventDefault();
    if (DEBUG) console.log("stringLot: ", stringLot);

    setInputLot(0);
    messagetemp = "";

    // on lit la liste des n° de lots entrés par l'utilisateur

    try {
        if (DEBUG) console.log(rappel);
        if (DEBUG) console.log(stringLot);
        lottemp = parseInt(stringLot.trim(), 10);
        if (DEBUG)console.log(lottemp);
        if (isNaN(lottemp)) {
          messagetemp = "Numero de lot incorrect";
          setMessage(messagetemp);
          return;
          //throw "err";
        } else if (lottemp <= 0) {
          messagetemp = "Numero de lot incorrect";
          setMessage(messagetemp);
          return;          
          //throw "err";
        } else if (!(await intchaine.existeLot(lottemp))) {
          messagetemp = "Ce lot n'existe pas";
          setMessage(messagetemp);
          return;
          //throw "err";
        } else if (!(await intchaine.verifierLotFournisseur(lottemp))) {
          messagetemp = "Vous n'etes pas le fournisseur de ce lot";
          setMessage(messagetemp);
          return;          
          //throw "err";          
        }

      if (DEBUG) console.log("dans try, lottemp: ", lottemp);
    } catch (e) {
      if (DEBUG) console.log("dans catch, lottemp: ", lottemp);
      messagetemp += "Erreur dans le numéro de lot";
      setMessage(messagetemp);
      return;
    }
    if (rappel) {
      //messagetemp = "rappel du lot " + lottemp;
      setInputLot(lottemp);
      setShowRappel(true);
    } else {
      let rappel_retourne = await intchaine.setRappelLot(lottemp, false);
      if (DEBUG) console.log("rappel retourné par le contrat cas faux: ", rappel_retourne);  
      if (DEBUG) console.log("rappel par getRappelLot par le contrat cas faux: ", await intchaine.getRappelLot(lottemp));   
      intbd.goSetRappelLot(lottemp, false);
      messagetemp = "Pas de rappel du lot " + lottemp;
    }
    setInputLot(lottemp);
    setMessage(messagetemp);

  }

  // listetemp = [{id:1, jsx: (<p>erreur dans la liste de lots</p>)}]
  // setInputList(listetemp);


async function rappelerLot(e, numLot) {
    if (DEBUG) console.log("je rappelle le lot " + numLot);
    let rappel_retourne = await intchaine.setRappelLot(numLot, true);
    if (DEBUG) console.log("rappel retourné par le contrat cas vrai: ", rappel_retourne);
    let rappelParGet = await intchaine.getRappelLot(numLot);
    if (DEBUG) console.log("rappelParGet par getRappelLot par le contrat cas vrai: ", rappelParGet);
    intbd.goSetRappelLot(numLot, true);

    setMessage("rappel du lot " + numLot)
    setShowRappel(false);
}

 // const liste = inputList.map((inp) => <div key={inp.id}>{inp.jsx}</div>);

  return (
    <>
      {/* <Button
        style={{ fontSize: 12, padding: 3 }}
        variant="outline-primary"
        onClick={handleAutreAffichage}
      >
        Autre selection de lots
      </Button>
      <br /> */}
      <br />
      <Form style={{ backgroundColor: "#d4d6d9" }}>
        <Form.Group className="mb-3">
          <Form.Label className="ps-2">Lot à rappeler</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez le numéro de lot à rappeler"
            value={stringLot}
            onChange={(e) => handleOnChange(e, e.target.value)}
          />
        </Form.Group>
      </Form>
      <Button
        style={{ fontSize: 12, padding: 3 }}
        variant="outline-primary"
        onClick={(e) => handleRappelerLot(e,true)}
      >
        Rappeler ce lot
      </Button>{" "}
      <Button
        style={{ fontSize: 12, padding: 3 }}
        variant="outline-primary"
        onClick={(e) => handleRappelerLot(e,false)}
      >
        Annuler le rappel
      </Button>      
      <br />
      <br />

      <div
        style={{
          paddingLeft: "60px",
          // marginLeft: "50px",
          // marginRight: "50px",
          borderStyle: "solid",
          borderWidth: "2px",
        }}
      >
        {message}
      </div>
      <Modal show={showRappel} onHide={handleCloseRappel}>
          <Modal.Header closeButton>
            <Modal.Title>Rappel Lot</Modal.Title>
          </Modal.Header>
          <Modal.Body>Etes-vous sûr de vouloir rappeler le lot {inputLot}?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseRappel}>
              Non
            </Button>
            <Button variant="secondary" onClick={(e) => rappelerLot(e, inputLot)}>
              Oui
            </Button>
          </Modal.Footer>
        </Modal>      
    </>
  );
}
